import * as React from "react"
import { AnalysisInsightsCarousel } from "src/frontend/components/OS/Applications/Analysis/AnalysisInsightsCarousel"
import { RevenueBarChart } from "src/frontend/components/OS/Applications/Analysis/Revenue/Overview/Widgets/RevenueBarChart"
import { WideWidgetTopContainer } from "src/frontend/components/OS/Shared/Widgets/WidgetContainer"

export const RevenueOverviewWidget: React.FC = () => (
  <WideWidgetTopContainer>
    <RevenueBarChart />
    <AnalysisInsightsCarousel />
  </WideWidgetTopContainer>
)
